<div class="container" *ngIf="business_info.strTitle">

    <main class="w-100 row gx-0 p-md-4 justify-content-center">

        <div class="col-12 col-md-6 px-md-4 pt-3 pt-md-0">

            <div class="business-header mb-2">

                <div class="business-social my-3 d-flex justify-content-center align-items-center">

                    <div class="social-container d-flex justify-content-center align-items-center">

                        <span *ngIf="business_info.strTelegram.trim() != '' " (click)="socialMedia('telegram')"
                            class="pointer d-flex align-items-center ms-3">

                            <i class="fa fa-telegram text-primary" style="font-size: 22px;"></i>

                        </span>

                        <span *ngIf="business_info.strWhatsUp.trim() != '' " (click)="socialMedia('whatsapp')"
                            class="pointer d-flex align-items-center ms-3">

                            <i class="fa fa-whatsapp text-success" style="font-size: 24px;"></i>

                        </span>

                        <span *ngIf="business_info.strInstagram.trim() != '' " (click)="socialMedia('instagram')"
                            class="pointer d-flex align-items-center ms-3">

                            <i class="fa fa-instagram text-danger" style="font-size: 24px;"></i>

                        </span>

                        <span *ngIf="business_info.strFacebook.trim() != '' " (click)="socialMedia('facebook')"
                            class="pointer d-flex align-items-center ms-3">

                            <i class="fa fa-facebook-official text-primary" style="font-size: 23px;"></i>

                        </span>

                    </div>

                </div>

                <span class="d-flex justify-content-center align-items-center pointer mt-1">

                    <mat-icon style="font-size: 25px;" class="text-muted">forum</mat-icon>

                </span>

                <span (click)="shareVia()" class="d-flex justify-content-center align-items-center mx-3 pointer">

                    <mat-icon style="font-size: 25px;" class="text-muted">share</mat-icon>

                </span>

                <span (click)="likeBusiness()" class="d-flex justify-content-center align-items-center pointer">

                    <mat-icon style="font-size: 25px;" [ngClass]="business_info.bLiked ? 'text-danger' : 'text-muted' ">

                        favorite

                    </mat-icon>

                </span>

            </div>

            <div class="business-information">

                <div class="business-name d-flex flex-column align-items-start mb-2">

                    <h2 class="mb-1 fw-bold text-secondary d-flex align-items-center">

                        <ng-container *ngIf="business_info?.bValid">

                            <mat-icon style="font-size: 21px;" class="mat-icon text-info" aria-hidden="true">

                                {{ business_info?.bValid ? 'verified' : '' }}

                            </mat-icon>

                        </ng-container>


                            <h1 class="mb-0 fw-bold tk-text-main">

                                <span [ngClass]="business_info?.bValid ? 'me-1' : '' ">

                                    {{business_info.strTitle | titlecase }}

                                </span>

                            </h1>


                    </h2>

                    <span class="code me-1 mb-2">کد کسب و کار :

                        {{business_info.iTaxiLon_User | faNum }}

                    </span>

                
                    <span class=" d-flex align-items-center ms-2">

                        <div class="crop" [style.width.px]="width">

                            <div style="width: 100px;">

                                <i class="fa fa-star"></i>

                                <i class="fa fa-star"></i>

                                <i class="fa fa-star"></i>

                                <i class="fa fa-star"></i>

                                <i class="fa fa-star"></i>

                            </div>

                        </div>

                    </span>

                </div>

                <div class="row gx-0 gx-md-3 w-100 business_info">

                    <div class="col-12">

                        <div class="business-category d-flex align-items-center mb-2">

                            <span class="d-flex align-items-center ms-2">

                                <mat-icon class="mat-icon text-muted" aria-hidden="true">category</mat-icon>

                            </span>

                            <h2 class="mb-0" style="font-size: 11px;line-height: 0px">

                                <span> {{business_info.strResume_Category_strComment}}</span>

                            </h2>

                        </div>

                    </div>

                    <div class="col-12">

                        <div class="business-category d-flex align-items-center mb-2">

                            <span class="d-flex align-items-center ms-2">

                                <mat-icon class="mat-icon text-muted " aria-hidden="true">list</mat-icon>

                            </span>

                            <h2 class="mb-0" style="font-size: 14px;line-height: 0px;">

                                <span> {{business_info.strResume_SubCategory_strComment}} </span>

                            </h2>
                        </div>

                    </div>

                    <div class="col-12">

                        <div class="business-category d-flex align-items-center mb-2">

                            <span class="d-flex align-items-center ms-2">

                                <mat-icon class="mat-icon text-muted" aria-hidden="true">today</mat-icon>

                            </span>

                            <span class="mx-2"> {{ business_info?.strWeekDays | faNum }} </span>


                        </div>

                    </div>

                    <div class="col-12">

                        <div class="business-category d-flex align-items-center mb-2">

                            <span class="d-flex align-items-center ms-2">

                                <mat-icon class="mat-icon text-muted " aria-hidden="true">access_time</mat-icon>

                            </span>

                            <span class="mx-2"> {{ business_info?.strHoursOperation | faNum }} </span>


                        </div>

                    </div>

                    <div *ngIf="business_info?.strTel" class="col-md-6 col-sm-6 col-12">

                        <div class="business-category d-flex align-items-center justify-content-between mb-2">

                            <span class="d-flex align-items-center ms-2">

                                <mat-icon class="mat-icon text-muted " aria-hidden="true">phone_in_talk</mat-icon>

                            </span>

                            <span class="mx-2"> {{ business_info?.strTel}} </span>


                        </div>

                    </div>

                    <div class="col-md-6 col-sm-6 col-12">

                        <div class="business-category d-flex align-items-center justify-content-between mb-2">

                            <span class="d-flex align-items-center ms-2">

                                <mat-icon class="mat-icon text-muted " aria-hidden="true">smartphone</mat-icon>

                            </span>

                            <span class="mx-2"> {{ business_info?.strMobile }} </span>


                        </div>

                    </div>

                    <div class="col-md-6 col-sm-6 col-12">

                        <div class="business-category d-flex align-items-center mb-2">

                            <span class="d-flex align-items-center ms-2">

                                <mat-icon class="mat-icon text-muted " aria-hidden="true">person_pin_circle</mat-icon>

                            </span>

                            <span class="mx-2"> {{ business_info?.strCityName | faNum }} </span>


                        </div>

                    </div>
                </div>

                <div *ngIf="business_info.lstResume_Expertise.length" class="business-experience my-3">
                    
                    <div style="background-color: #F0FAFF;" class="rounded-sm my-4 p-3 ">

                        <p class="fw-bold"> هشدار </p>

                        <span style="font-size: 12px;" class="text-muted">

                            امدادران در قبال مشخصات کسب و کارهایی که خود آنها را تایید ننموده است، مسئولیتی ندارد.

                        </span>

                    </div>

                    <div *ngIf="business_info.lstResume_Expertise?.length" class="business-experience my-3">

                        <h3 class="fw-bold">سایر تخصص ها </h3>

                        <ng-container *ngFor="let item of business_info.lstResume_Expertise">

                            <div class="d-flex flex-column">

                                <span class="d-flex align-items-center ms-2">

                                    <mat-icon class="mat-icon text-muted ms-2">military_tech</mat-icon>

                                    <span class="fw-bold"> {{ item.strResume_Category_strComment + ' , ' +
                                        item.strResume_SubCategory_strComment }} </span>

                                </span>

                                <span *ngIf="item.strComment" class="me-2 mt-2"> توضیحات : {{item.strComment}} </span>

                            </div>

                            <div class="divider"></div>

                        </ng-container>

                    </div>

                    <div *ngIf="business_info?.strWebsite" class="business-category_main d-flex align-items-center justify-content-between mb-2">

                        <span class="d-flex align-items-center ms-2">

                            <mat-icon class="mat-icon text-muted ">explore</mat-icon>

                        </span>

                        <span>

                            <a target="_blank" href="{{business_info?.strWebsite}}">

                                {{business_info?.strWebsite}}

                            </a>

                        </span>

                    </div>

                    <div *ngIf="business_info.strCV?.trim() != '' " class="business-description ps-md-4 d-flex align-items-start my-3">

                        <span style="line-height: 30px;"> {{ business_info.strCV | faNum }} </span>

                    </div>


                </div>

                <div class="business-description ps-md-4 d-flex align-items-start my-3">

                    <span style="line-height: 30px;" [innerText]="business_info.strCV | faNum"></span>

                </div>
                            
            </div>

        </div>

        <div class="skills-container col-12 col-md-6">

            <div class="ads-images-container h-65">

                <!-- عکس اصلی -->

                <div class="ads-images-preview h-75">

                    <div class="position-relative w-full h-100 rounded">

                        <img class="w-100 h-100 rounded" [alt]="business_info.strTitle" loading="lazy" src="{{mainImage_ads?.strImage  ? 'data:image/jpeg;base64,' + mainImage_ads?.strImage : '../../../assets/imgs/preview__thumbnail.png'}}">

                        <span *ngIf="list_AdsImages.length > 0" class="position-absolute pointer" (click)="openGallery(list_AdsImages?.[0],0)"> 
                            
                            <mat-icon> fullscreen </mat-icon>

                            {{ list_AdsImages.length | faNum }}
                        
                        </span>

                    </div>

                </div>

                <!-- بقیه تصاویر -->

                <div *ngIf="list_AdsImages.length > 1" class="ads-images-all w-full row dil gx-2 pt-1 h-25">

                    <div *ngFor="let item of list_AdsImagesShown;let i = index" class="ads-image col-md-4 col-6 p-2">

                        <div class="w-full h-100 rounded position-relative" (click)="openGallery(item,i)">

                            <ng-container *ngIf="i == 0">

                                <div *ngIf="list_AdsImagesCounter > 0" class="pic-counter pointer">

                                    +{{ list_AdsImagesCounter | faNum }}

                                </div>

                            </ng-container>

                            <img class="w-100 h-100 rounded" src="{{'data:image/jpeg;base64,'+ item.strImage}}" [alt]="business_info.strTitle" loading="lazy">

                        </div>

                    </div>

                </div>
                
                <div class="ads-note my-2 w-full">

                    <textarea id="textArea_" [ngModel]="business_info.strUserComment" cols="10" rows="4"  class="form-control mb-1" placeholder="یادداشت شما ..."></textarea>

                    <small class="text-muted">

                        یادداشت اختصاصی شما که پس از حذف کسب و کار, حذف خواهد شد.

                    </small>

                </div>

                <div *ngIf="business_info.fLat !== 0 && business_info.fLon !==0" id="ads-location" class="w-100 mt-4" style="max-height: 220px !important;">

                    <div id="test" style="width: 100%; height: 200px;" class="mx-auto root_but">

                        <button (click)="routeToMap(business_info)" class="btn btn-primary">

                            <mat-icon>directions</mat-icon>

                        </button>

                        <div class="position-absolute" id="map_tooltip" data-bs-html="true"> </div>

                    </div>

                </div>

                <div *ngIf="business_info?.strAddress" class="adres p-2">

                    <span class=""> <strong> آدرس : </strong> {{business_info.strAddress}} </span>

                </div>

            </div>

        </div>

        <div class="col-12">

            <div class="col-md-6 col-12">

                <div *ngIf="!business_info?.bValid" class="ads-warning my-3 w-100 d-flex justify-content-start align-items-center">

                    <div class="d-flex align-items-start px-2 flex-column">
    
                        <p class="fw-bold mb-1 mx-2" style="font-size: 14px;"> امنیت </p>
    
                        <span style="font-size: 12px;" class="mx-2">
    
                            امدادران در قبال مشخصات کسب و کارهایی که خود آنها را تایید ننموده است، مسئولیتی ندارد.
    
                        </span>
    
                    </div>
    
                </div>
    
                <!-- گزارش کلاهبرداری -->
    
                <div class="ads-warning w-100 mt-3 mb-2 d-flex justify-content-between align-items-center pointer" (click)="goToSupport()">
    
                    <div class="d-flex align-items-center">
    
                        <span class="d-flex material-symbols-outlined">
    
                            <mat-icon>warning</mat-icon>
    
                        </span>
    
                        <span class="mx-2"> 
    
                            گزارش کسب و کار با کد
    
                            {{business_info.iTaxiLon_User | faNum }}
    
                            
                        </span>
    
                    </div>
    
                    <span class="d-flex material-symbols-outlined mr-4">
    
                        <mat-icon class="mat-18  text-muted">chevron_left</mat-icon>
    
                    </span>
    
                </div>
                
            </div>

        </div>

    </main>

</div>

<section *ngIf="sliderSimilar.length > 3" class="container">

    <section *ngIf="sliderSimilar?.length > 3" class="container">

        <div class="central sec_title my-5">

            <i class="fa fa-bullhorn" aria-hidden="true"></i>

            <h3>

                کسب و کار های مرتبط

            </h3>

        </div>

        <owl-carousel-o [options]="carouselOptions">

            <ng-template *ngFor="let item of sliderSimilar" carouselSlide>

                <div class="p-2 h-100">

                    <div (click)="open_Business(item,i)" class="adds_box h-100">

                        <div class="img_box">

                            <span>{{item.strResume_Category_strComment | faNum}}</span>

                            <P>{{item.strResume_SubCategory_strComment | faNum}}</P>

                            <img *ngIf="item.strImage" src="data:image/png;base64,{{item.strImage}}" loading="lazy"
                                alt="{{item.strSearchContent}}">

                            <img *ngIf="!item.strImage" src="../../../assets/imgs/Shahrnik_Logo_Public_new.png" loading="lazy"
                                alt="{{item.strSearchContent}}">

                        </div>

                        <div class="detail_box w-100 h-100">

                            <div>

                                <h3 class="text-secondary fw-bold mx-0 mb-1" style="font-size: 13px;">

                                    {{ subString_Title(item.strSearchContent,39 | faNum) }}

                                </h3>

                            </div>

                            <div class="d-flex justify-content-between w-100 ">

                                <div class="w-100 d-flex flex-column">

                                    <span dir="ltr"
                                        style="height: 40px;max-height: 21px;font-style: italic;font-size: 13px;"
                                        [title]="item.strAddress">

                                        {{ subString_Title(item.strAddress,32) }}

                                    </span>

                                    <div class="text-muted d-flex justify-content-between align-items-center">

                                        <div class="">

                                            <span class="text-muted" style="font-size: 13px;">{{item.strWeekDays|
                                                faNum}}</span> -

                                            <span class="text-muted" style="font-size: 13px;">{{item.strHoursOperation|
                                                faNum}}</span>

                                        </div>

                                        <div
                                            class="ads-badge rounded d-flex justify-content-center align-items-center text-muted">

                                            <!-- <ng-container>

                                            <small class="fw-bold">{{item.iView | faNum}}</small>

                                            <mat-icon>visibility</mat-icon>

                                        </ng-container> -->

                                            <!-- <mat-icon>
    
                                            {{
    
                                            item.tiType == 0 ? 'chair_alt' :
    
                                            item.tiType == 1 ? 'diversity_1' :
    
                                            item.tiType == 2 ? 'business_center' :
    
                                            item.tiType == 3 ? 'patient_list' :
    
                                            item.tiType == 4 ? 'home_work' : 'category'
    
                                            }}
    
                                        </mat-icon> -->

                                        </div>

                                    </div>

                                </div>

                                <!-- <div class="mx-2 central border border-2 border-danger">
    
                                <span>{{item.iView | faNum}}</span>
    
                                <mat-icon>visibility</mat-icon>
    
                            </div> -->

                            </div>

                        </div>


                    </div>

                    <!-- list bookmark && list recent visits -->


                </div>

            </ng-template>
        </owl-carousel-o>
    </section>

    <div class="modal fade" id="full-gallery" data-bs-keyboard="false" data-bs-backdrop="static">

        <div [style]="fullscreen_ModalStyle" class="modal-dialog modal-dialog-centered">

            <div style="height: 100%;background-color:#000000cf;" class="modal-content">

                <div class="modal-header border-0">

                    <button type="button" class="btn btn-danger central" (click)="closeImgModal()">

                        <mat-icon class="mat-18">close</mat-icon>

                    </button>

                </div>

                <div class="position-relative modal-body central">

                    <img src="{{current_Image?.strImage}}" loading="lazy" alt="گالری تصاویر">

                    <span class="album-btn next-btn" (click)="next_Image()">

                        <mat-icon class="mat-18">arrow_forward_ios</mat-icon>

                    </span>

                    <span class="album-btn prev-btn" (click)="prev_Image()">

                        <mat-icon class="mat-18">arrow_back_ios_new</mat-icon>

                    </span>

                    <div *ngIf="current_Image?.strComment?.trim() != '' " class="image-description text-center w-100 p-2">

                        <span id="span" (click)="showComplete_Text()">{{current_Image?.strComment}}</span>

                    </div>

                </div>

            </div>

        </div>

    </div>

</section>

<!-- لینک های مرتبط -->

<div class="central border-top border-1 ">

    <section class="container row gx-0 gy-3 pb-3 px-3">

        <div class="central sec_title mt-5 my-3">

            <i class="fa fa-link" aria-hidden="true"></i>

            <h2 class="mb-0"> لینک های مرتبط </h2>

        </div>

        <ng-container *ngFor="let item of lst_links">

            <a [href]="item.strURL" target="_blank" [title]="item.strTitle">
            
                {{ item.strTitle | faNum }} 
            
            </a>

        </ng-container>

    </section>

</div>
    
<!-- گالری تصاویر -->

<div class="modal fade dir" id="galleryComp_Modal" role="dialog" style="z-index: 1000!important;">

    <div class="modal-dialog modal-fullscreen modal-dialog-centered">

        <div class="modal-content">

            <div class="modal-header d-flex justify-content-between">

                <h3 class="modal-title mb-0"> گالری تصاویر </h3>

                <button type="button" class="btn-close p-0 m-0" data-bs-dismiss="modal"></button>

            </div>

            <div class="modal-body">

                <ng-container *ngIf="isAlbum">

                    <custom-gallery 
                    
                        [albumIndex]="albumIndex"

                        [lst_Album]="lst_Album"

                        [isDownloadAble]="false"
                        
                        [strKey_list]="'strImage'">
                
                    </custom-gallery>
                    
                </ng-container>

            </div>

        </div>

    </div>

</div>
